import { render, staticRenderFns } from "./Headline2.vue?vue&type=template&id=2f06f652&scoped=true"
import script from "./Headline2.vue?vue&type=script&lang=js"
export * from "./Headline2.vue?vue&type=script&lang=js"
import style0 from "./Headline2.vue?vue&type=style&index=0&id=2f06f652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f06f652",
  null
  
)

export default component.exports